import * as React from 'react';
import styled from 'styled-components';
import { TableOfContentGrammarLanding } from './TableOfContentGrammarLanding';
import { scrollBarStylesGeneral } from '@doltech/utils/lib/css-style';
import { fromScreen } from '@doltech/core/lib/responsive/responsive.util';

const Main = styled.div.withConfig({
  componentId: 'BlogTableOfContent_Main',
} as any)`
  #blog-table-of-content {
    width: 214px;
    min-width: 214px;
    max-width: 214px;
    overflow-y: auto;
    min-height: 90vh;
    max-height: 90vh;
    padding: 0 8px;
    ${scrollBarStylesGeneral()};

    ${fromScreen(1446)} {
      width: 320px;
      min-width: 320px;
      max-width: 320px;
    }
  }
`;

export const BlogTableOfContent = (props) => (
  <Main className="blog-table-of-content">
    <TableOfContentGrammarLanding {...props} />
  </Main>
);
